var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9351 8.81738C16.1671 8.81738 17.3486 9.30678 18.2197 10.1779C19.0908 11.0491 19.5802 12.2306 19.5802 13.4625V18.8819H16.4835V13.4625C16.4835 13.0519 16.3203 12.658 16.03 12.3677C15.7396 12.0773 15.3457 11.9142 14.9351 11.9142C14.5244 11.9142 14.1306 12.0773 13.8402 12.3677C13.5498 12.658 13.3867 13.0519 13.3867 13.4625V18.8819H10.2899V13.4625C10.2899 12.2306 10.7793 11.0491 11.6505 10.1779C12.5216 9.30678 13.7031 8.81738 14.9351 8.81738V8.81738Z",
    stroke: "#2B3036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19315 9.59082H4.09637V18.8811H7.19315V9.59082Z",
    stroke: "#2B3036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64476 7.26865C6.49991 7.26865 7.19315 6.57541 7.19315 5.72026C7.19315 4.86511 6.49991 4.17188 5.64476 4.17188C4.78961 4.17188 4.09637 4.86511 4.09637 5.72026C4.09637 6.57541 4.78961 7.26865 5.64476 7.26865Z",
    stroke: "#2B3036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 4.5,
    stroke: "#2B3036"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a87aca30d2b02acfb25ae1f12f85b558.svg";
export { ForwardRef as ReactComponent };